module.exports = __webpack_public_path__ + "img/chat_emoticon_synot_005.png?9068204c9ed546713dbf6de7dfdc560c";